import cn from "classnames";
import { paths } from "helpers/paths";
import { useLocalStorage } from "hooks/useLocalStorage";
import React from "react";

export default function CloneDistributionBid(props) {
    const [clearDates, setClearDates] = useLocalStorage("clear-dates-on-clone-distribution-bid", true);
    const createCopy = () => {
        props.history.push(
            `${paths.distributionBidsNew}?sourceId=${props.distributionBidId}${clearDates ? "&isCopy=true" : ""}`,
        );
    };
    return (
        <div>
            <div className="col-form-label-sm d-inline-block mb-3" onClick={() => setClearDates(!clearDates)}>
                <div className={cn("checkbox d-inline-block", { "checkbox--checked": clearDates })} />
                &nbsp;
                <div className="d-inline-block checkbox__text">Сбросить даты точек загрузки/выгрузки</div>
            </div>
            <div className="btn btn-sm btn-brand btn-block" onClick={createCopy}>
                Создать копию заказа
            </div>
        </div>
    );
}
